module.exports = __webpack_public_path__ + "static/media/checkbox-blank.20c063ef.svg";